import SEO from '../components/SEO/SEO'
import Link from 'next/link'
import { useState } from 'react'
import FaqAccordian from '../components/FaqAccordian/FaqAccordian'
import TextInput from '../components/TextInput/TextInput'
import Layout from '../layout/Layout'

const Faq = () => {
  const [search, setSearch] = useState('')
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="h-full w-full object-cover"
                  src="banner/faq-banner.png"
                  alt="Evry Health frequently asked questions"
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="relative px-4 py-16 md:py-16 lg:py-32 max-w-screen-xl mx-auto">
                  <h1 className="text-3xl md:text-5xl tracking-tight text-darkBlue">
                    You have questions. <br />{' '}
                    <span className="text-globeGreen">We have answers.</span>
                  </h1>
                </div>
                <div className="relative px-4 py-16 sm:px-6 md:py-32 md:px-0 flex items-center">
                  <form className="w-full flex items-center">
                    <div className="max-w-500 m-5/6 md:w-full inline-block">
                      <input
                        className="bg-white-light min-w-500px border-none w-full py-6 px-5"
                        min="2"
                        value={search}
                        onChange={e => {
                          setSearch(e.target.value)
                        }}
                      />
                    </div>
                    <button
                      className="ml-8 inline-block bg-orange p-2 rounded-full"
                      type="submit"
                      onSubmit={e => {
                        e.preventDefault()
                      }}
                    >
                      <object
                        type="image/svg+xml"
                        data="search-icon.svg"
                        className="h-8 w-auto"
                      />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl mx-auto py-12 px-6 md:px-0">
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-8">
              <div className="col-span-2 md:col-span-1">
                <FaqAccordian />
              </div>
              <div className="col-span-2 md:col-span-1 text-center">
                <div className="sticky top-28">
                  <h4 className="text-3xl md:text-4xl pb-8">
                    Need personal attention?
                  </h4>
                  <div className="flex mx-auto justify-center">
                    <Link href="/">
                      <span className="bg-blue text-white font-medium py-2 px-6 md:px-12 text-lg mr-4">
                        Email Us
                      </span>
                    </Link>

                    <Link href="/">
                      <span className="bg-blue text-white font-medium py-2 px-6 md:px-12 text-lg ml-4">
                        Call Us
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default Faq
